import React from 'react';
import styled from 'styled-components';
import { Translation } from '~/components/Translation';
import ResponsiveText from '~/components/ResponsiveText';
import StepCard from './components/StepCard';

const Container = styled.div`
	display: flex;
	padding: 80px 120px;
	flex-direction: column;
	align-items: center;
	gap: 40px;

	@media (max-width: 1080px) {
		padding: 40px 20px;
	}
`;

const HeaderContainer = styled.div`
	display: flex;
	max-width: 620px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 24px;
`;

const Title = styled(ResponsiveText)`
	text-align: center;
`;

const Subtitle = styled(ResponsiveText)`
	justify-self: center;
	text-align: center;
	margin: 0 50px;
	max-width: 800px;

	@media (max-width: 500px) {
		margin: 0 50px;
	}
`;

const StepsContainer = styled.div`
	display: flex;
	gap: 32px;
	justify-content: center;
	flex-wrap: wrap;
	width: 100%;
	max-width: 1200px;
`;

export interface Step {
	imageSrc: string;
	titleKey: string;
	descriptionKey: string;
	stepLabelKey?: string;
}

interface GettingStartedStepsProps {
	titleKey: string;
	subtitleKey?: string;
	steps: Step[];
}

const GettingStartedSteps: React.FC<GettingStartedStepsProps> = ({
	titleKey,
	subtitleKey,
	steps,
}) => {
	return (
		<Container>
			<HeaderContainer>
				<Title variant="h2">
					<Translation tid={titleKey} />
				</Title>
				{subtitleKey && (
					<Subtitle variant="body">
						<Translation tid={subtitleKey} />
					</Subtitle>
				)}
			</HeaderContainer>
			<StepsContainer>
				{steps.map((step, index) => (
					<StepCard
						key={index}
						stepNumber={index + 1}
						imageSrc={step.imageSrc}
						titleKey={step.titleKey}
						descriptionKey={step.descriptionKey}
						stepLabelKey={step.stepLabelKey}
					/>
				))}
			</StepsContainer>
		</Container>
	);
};

export default GettingStartedSteps;
